exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// D:/git/platform/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 1 4